import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=5992ee28"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports